import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useCombinedStore } from "../store";
import Modal from "react-modal";
import api from "../services/api.service";
import * as Styles from "../styles/CreateCustomerAddress.Modal.styles";
import alfredoIcon from "../assets/alfredo-icon.svg";
//import { AddressAutocomplete } from "./AddressAutocomplete";
import { z } from "zod";
import { set } from "date-fns";

const NewCustomerAddressModal: React.FC<{
  isOpen: boolean;
  onRequestClose: () => void;
  searchValueInput: string;
  setSearchValueInput: (value: string) => void;
  customerInfoByOrder: any;
  setCustomerInfoByOrder: (value: any) => void;
}> = ({
  isOpen,
  onRequestClose,
  searchValueInput,
  setSearchValueInput,
  customerInfoByOrder,
  setCustomerInfoByOrder,
}) => {
    const [error, setError] = useState<any>({});
    const {
      setSubsidiaryDataZustand,
      subsidiaryDataZustand,
      setOrderDataZustand,
      orderDataZustand,
      setMessageZustand,
      authUserZustand,
    } = useCombinedStore((state) => {
      return {
        setSubsidiaryDataZustand: state.setSubsidiaryDataZustand,
        subsidiaryDataZustand: state.subsidiaryDataZustand,
        setOrderDataZustand: state.setOrderDataZustand,
        orderDataZustand: state.orderDataZustand,
        setMessageZustand: state.setMessageZustand,
        authUserZustand: state.authUserZustand,
      };
    });
    const customerPhoneInputRef = useRef<HTMLInputElement>(null);
    const customerNameInputRef = useRef<HTMLInputElement>(null);
    const customerAddressInputRef = useRef<HTMLInputElement>(null);
    const customerAddressComplementInputRef = useRef<HTMLInputElement>(null);
    const customerAddressObservationInputRef = useRef<HTMLInputElement>(null);
    const customerOriginInputRef = useRef<HTMLSelectElement>(null);
    const modalWrapperRef = useRef<HTMLDivElement>(null);

    const [CustomerPhone, setCustomerPhone] = useState<string>(searchValueInput);
    const [CustomerName, setCustomerName] = useState<string>("");
    // const [CustomerNewAddress, setCustomerNewAddress] = useState({
    //   placeId: "",
    //   formattedAddress: "",
    // });

    const [CustomerAddress, setCustomerAddress] = useState<string>("");
    const [CustomerAddressComplement, setCustomerAddressComplement] =
      useState<string>("");
    const [CustomerAddressObservation, setCustomerAddressObservation] =
      useState<string>("");
    const [CustomerOrigin, setCustomerOrigin] = useState("directContact");
    //criar campo dropdown com as origens (aplicativo interno, externo...)
    const [isSubmitting, setIsSubmitting] = useState(false); // Controla a submissão

    setTimeout(() => {
      setCustomerPhone(searchValueInput);
    }, 50);

    const handleSubmit = async () => {
      if (isSubmitting) return; // Evita submissões múltiplas

      setIsSubmitting(true);

      if (CustomerPhone && CustomerName && CustomerAddress !== "" && CustomerOrigin) {
        try {
          const CustomerResponse = await api.post(`customerAddress`, {
            customerPhone: CustomerPhone,
            customerName: CustomerName,
            //customerPlaceId: CustomerNewAddress.placeId,
            //customerFormattedAddress: CustomerNewAddress.formattedAddress,
            customerAddress: CustomerAddress,
            customerAddressComplement: CustomerAddressComplement,
            customerAddressObservation: CustomerAddressObservation,
            customerOrigin: CustomerOrigin,
          });
          setSubsidiaryDataZustand({
            ...subsidiaryDataZustand,
            subsidiaryInfo: subsidiaryDataZustand.subsidiaryInfo.map(
              (info: any) =>
                info.subsidiaryInfoType === 1
                  ? {
                    ...info,
                    subsidiaryInfoValue: {
                      ...info.subsidiaryInfoValue,
                      Customers: CustomerResponse.data.customers.Customers,
                    },
                  }
                  : info
            ),
          });

          const customerUuid = CustomerResponse.data.customers.Customers.find(
            (customer: any) => customer.customerPhone === CustomerPhone
          )?.customerUuid;
          const openOrderResponse = await api.post(`order`, {
            orderOwnerUuid: authUserZustand?.userInfo.userUuid,
            period: subsidiaryDataZustand.selectedPdv.selectedPeriod.periodUuid,
            orderType: "DELIVERY",
            orderInfo: {
              customerUuid: customerUuid,
              customerAddress: CustomerAddress,
              //customerPlaceId: CustomerNewAddress.placeId,
            },
          });
          if (openOrderResponse.status === 201) {
            setOrderDataZustand({
              ...orderDataZustand,
              orderUuid: openOrderResponse.data.order?.createdOrder?.orderUuid,
              orderCode: openOrderResponse.data.order?.createdOrder?.orderCode,
              orderOwnerUuid:
                openOrderResponse.data.order?.createdOrder?.updatedByUuid
                  .userUuid,
              orderOwnerName:
                openOrderResponse.data.order?.createdOrder?.updatedByUuid
                  .userSocialName,
              orderStatus: 0,
              orderType: "3",
              createdAt: openOrderResponse.data.order?.createdOrder?.createdAt,
              orderInfo: {
                customerUuid: customerUuid,
                customerName: CustomerName,
                customerAddress: CustomerAddress,
                //customerPlaceId: CustomerNewAddress.placeId,
                //customerFormattedAddress: CustomerNewAddress.formattedAddress,
                customerAddressComplement: CustomerAddressComplement,
                customerAddressObservation: CustomerAddressObservation,
              },
              products: [],
              totals: {},
            });

            setSearchValueInput(`Fone: ${CustomerPhone}`);
            const CustomerOriginLabel =
              CustomerOrigin === "directContact"
                ? "Telefone"
                : CustomerOrigin === "externalApp"
                  ? "Aplicativo externo (Ifood, Rappi...)"
                  : CustomerOrigin === "internalApp"
                    ? "Aplicativo interno (Alfredo, Lucco)"
                    : "Outros";
            setCustomerInfoByOrder({
              customerName: CustomerName,
              customerAddress: CustomerAddress,
              //customerAddress: CustomerNewAddress.formattedAddress,
              customerAddressComplement: CustomerAddressComplement,
              customerAddressObservation: CustomerAddressObservation,
              customerOrigin: CustomerOriginLabel,
              customerPhone: `Fone: ${CustomerPhone}`,
            });
            setMessageZustand(
              `Pedido ${openOrderResponse.data.order?.createdOrder?.orderCode} aberto com sucesso!`,
              `success`
            );
          }
          onRequestClose();
          // setCustomerNewAddress({
          //   placeId: "",
          //   formattedAddress: "",
          // });
          setCustomerAddress("");
          setCustomerAddressComplement("");
          setCustomerAddressObservation("");
          setCustomerName("");
        } catch (error) {
          setMessageZustand("Erro ao cadastrar o cliente!", "error");
        } finally {
          setIsSubmitting(false); // Libera a submissão novamente
        }
      } else {
        setMessageZustand("Preencha todos os campos obrigatórios.", "error");
        setIsSubmitting(false); // Libera a submissão em caso de erro
      }
    };

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter" &&
        //CustomerNewAddress.placeId !== ""
        CustomerAddress !== "") {
        event.preventDefault();
        handleSubmit();
      } else if (event.key === "Escape") {
        onRequestClose();
        // setCustomerNewAddress({
        //   placeId: "",
        //   formattedAddress: "",
        // });
        setCustomerAddressComplement("");
        setCustomerAddressObservation("");
        setCustomerName("");
      } else if (
        event.key === "Tab" &&
        CustomerAddress !== "" &&
        //CustomerNewAddress.placeId !== "" &&
        CustomerPhone !== "" &&
        CustomerName !== "" &&
        CustomerAddressComplement === ""
      ) {
        event.preventDefault();
        customerAddressComplementInputRef.current?.focus();
      } else if (
        event.key === "Tab" &&
        CustomerAddress !== "" &&
        //CustomerNewAddress.placeId !== "" &&
        CustomerPhone !== "" &&
        CustomerName !== "" &&
        CustomerAddressComplement !== "" &&
        CustomerAddressObservation === ""
      ) {
        event.preventDefault();
        customerAddressObservationInputRef.current?.focus();
      } else if (
        event.key === "Tab" &&
        CustomerAddress !== "" &&
        //CustomerNewAddress.placeId !== "" &&
        CustomerPhone !== "" &&
        CustomerName !== "" &&
        CustomerAddressComplement !== "" &&
        CustomerAddressObservation !== "" &&
        CustomerOrigin === ""
      ) {
        event.preventDefault();
        customerOriginInputRef.current?.focus();
      }
    };
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        style={Styles.customStyles}
        contentLabel="Main Modal"
        ariaHideApp={false}
      >
        <Styles.ModalWrapper
          tabIndex={-1}
          ref={modalWrapperRef}
          onKeyDown={handleKeyPress}
        >
          <Styles.CloseButton
            onClick={() => {
              onRequestClose();
              setCustomerAddress("");
              // setCustomerNewAddress({
              //   placeId: "",
              //   formattedAddress: "",
              // });
              setCustomerAddressComplement("");
              setCustomerAddressObservation("");
              setCustomerName("");
            }}
          >
            &times;
          </Styles.CloseButton>
          <Styles.ModalContent>
            <Styles.ModalHeader
              color={
                subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                  .buttonsColor
              }
            >
              <Styles.Logo src={alfredoIcon} alt="Alfredo Web OPS" />
              <Styles.ModalTitle>Cadastro de Cliente</Styles.ModalTitle>
              <Styles.ModalDescription>{`Crie um novo endereço para o cliente receber suas entregas.`}</Styles.ModalDescription>
            </Styles.ModalHeader>
            <Styles.ModalBody
              color={
                subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                  .backgroundColor
              }
            >
              <Styles.RowContainer>
                <Styles.FieldContainer widht="50%">
                  <Styles.TextInput
                    color={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .buttonsColor
                    }
                  >
                    <input
                      type="text"
                      onKeyDown={handleKeyPress}
                      ref={customerPhoneInputRef}
                      placeholder=""
                      autoFocus={CustomerPhone === "" ? true : false}
                      value={CustomerPhone}
                      onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        setSearchValueInput(e.target.value);
                        setCustomerPhone(e.target.value);
                      }}
                    />
                    <label>Telefone do Cliente</label>
                  </Styles.TextInput>
                </Styles.FieldContainer>
                <Styles.FieldContainer widht="50%">
                  <Styles.TextInput
                    color={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .buttonsColor
                    }
                  >
                    <input
                      type="text"
                      onKeyDown={handleKeyPress}
                      autoFocus={CustomerPhone === "" ? false : true}
                      ref={customerNameInputRef}
                      placeholder=""
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        setCustomerName(e.target.value)
                      }
                      onKeyPress={handleKeyPress}
                    />
                    <label>Nome do Cliente</label>
                  </Styles.TextInput>
                </Styles.FieldContainer>
              </Styles.RowContainer>
              <Styles.RowContainer>
                <Styles.FieldContainer widht="70%"> <Styles.TextInput
                  color={
                    subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                      .buttonsColor
                  }
                >
                  <input
                    type="text"
                    onKeyDown={handleKeyPress}
                    placeholder=""
                    ref={customerAddressInputRef}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      setCustomerAddress(e.target.value)
                    }
                  />
                  <label>Endereço do Cliente</label>
                </Styles.TextInput>
                  {/* <Styles.AddressInput
                    color={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .buttonsColor
                    }
                    onKeyDown={handleKeyPress}
                  >
                   

                    <AddressAutocomplete
                      setCustomerNewAddress={setCustomerNewAddress}
                      setError={setError}
                    />
                    <label>Endereço do Cliente</label>
                  </Styles.AddressInput> */}
                </Styles.FieldContainer>

                <Styles.FieldContainer widht="30%">
                  <Styles.TextInput
                    color={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .buttonsColor
                    }
                  >
                    <input
                      type="text"
                      onKeyDown={handleKeyPress}
                      placeholder=""
                      ref={customerAddressComplementInputRef}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        setCustomerAddressComplement(e.target.value)
                      }
                    />
                    <label>Complemento</label>
                  </Styles.TextInput>
                </Styles.FieldContainer>
              </Styles.RowContainer>
              <Styles.RowContainer>
                <Styles.FieldContainer widht="50%">
                  <Styles.TextInput
                    color={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .buttonsColor
                    }
                  >
                    <input
                      type="text"
                      placeholder=""
                      onKeyDown={handleKeyPress}
                      ref={customerAddressObservationInputRef}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        setCustomerAddressObservation(e.target.value)
                      }
                    />
                    <label>Observações</label>
                  </Styles.TextInput>
                </Styles.FieldContainer>
                <Styles.FieldContainer widht="50%">
                  <Styles.DropdownInput
                    color={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .buttonsColor
                    }
                  >
                    <select
                      ref={customerOriginInputRef}
                      onChange={(e) => {
                        setCustomerOrigin(e.target.value);
                      }}
                    >
                      <option value="directContact">Telefone</option>
                      <option value="externalApp">
                        Aplicativo externo (Ifood, Rappi...)
                      </option>
                      <option value="internalApp">
                        Aplicativo interno (Alfredo, Lucco)
                      </option>
                    </select>
                    <label>Origem do Cliente</label>
                  </Styles.DropdownInput>
                </Styles.FieldContainer>
              </Styles.RowContainer>
            </Styles.ModalBody>
            <Styles.ModalFooter
              color={
                subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                  .buttonsColor
              }
            >
              <Styles.Button
                onClick={() => {
                  setCustomerInfoByOrder({
                    customerName: "",
                    customerAddress: "",
                    customerAddressComplement: "",
                    customerAddressObservation: "",
                    customerOrigin: "",
                    customerPhone: "",
                  });
                  // setCustomerNewAddress({
                  //   placeId: "",
                  //   formattedAddress: "",
                  // });
                  setCustomerAddress("");
                  setCustomerAddressComplement("");
                  setCustomerAddressObservation("");
                  setCustomerName("");
                  onRequestClose();
                }}
              >
                Cancelar
              </Styles.Button>
              <Styles.Button onClick={handleSubmit}>
                Cadastrar Endereço
              </Styles.Button>
            </Styles.ModalFooter>
          </Styles.ModalContent>
        </Styles.ModalWrapper>
      </Modal>
    );
  };

export default NewCustomerAddressModal;
